$.uiBackCompat = true;
import '@alias_root/vendor/jquery-ui/jquery-ui.js';

// Required for REACT-Components inside a UiDialog instance, to prevent focus error in react select components
// The original function does nothing but setting the focus to the first element with autofocus attribute / tabbable element / or falling back to the dialog itself.

// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
$.ui.dialog.prototype._focusTabbable = () => {
	/* empty */
};

import '@alias_root/vendor/jquery-ui/ui-lightness/jquery-ui.css';
